export const BASE_CHECKOUT_EVENT_PROPS = {
  page: "checkout",
};

export const CHECKOUT_EVENTS = {
  // Cart management
  PLAN_ADDED_TO_CART: "cart_item_added",
  ADDON_ADDED_TO_CART: "cart_item_added",
  // Migration
  SWAP_TO_EQUIVALENT_PLAN: "cart_item_added",
  UPGRADE_TO_BUNDLE_PLAN: "cart_item_added",

  ITEM_REMOVED_FROM_CART: "cart_item_removed",
  ADDON_QUANTITY_CHANGED: "addon_quantity_changed",

  // Promo codes
  PROMO_CODE_APPLIED: "promo_code_applied",
  PROMO_CODE_REMOVED: "promo_code_removed",

  // Summary
  SUMMARY_LOADED: "checkout_summary_loaded",
  SUMMARY_FAILED: "checkout_summary_failed",

  // Checkout actions
  CHECKOUT_INITIATED: "checkout_clicked",
  CHECKOUT_COMPLETED: "checkout_completed",
  CHECKOUT_FAILED: "checkout_failed",

  // Subscription management
  PAUSE_DIALOG_OPENED: "pause_subscription_clicked",
  CANCEL_DIALOG_OPENED: "cancel_subscription_clicked",
  PLAN_REMOVAL_CONFIRMED: "checkout_plan_removal_confirmed",
  PLANS_CHANGE_DIALOG_CONFIRMED: "plans_change_dialog_confirmed",
  REACTIVATION_SUCCESS: "checkout_reactivation_success",

  // Switch-to-yearly dialog (same wire event the dashboard banner fires — the two
  // entry points share the dialog, so they share the funnel step)
  INTERVAL_SWITCH_MODAL_VIEWED: "interval_switch_modal_viewed",

  // Add_on management
  ADDON_MANAGER_OPENED: "existing_addon_manage_clicked",
  GALLERY_MANAGER_OPENED: "existing_gallery_manage_clicked",

  // Pause subscription dialog actions
  PAUSE_MODAL_VIEWED: "pause_modal_viewed",
  PAUSE_SUBSCRIPTION_CONFIRMED: "pause_subscription_confirmed",
  PAUSE_SUBSCRIPTION_CANCELLED: "pause_subscription_cancelled",
  PAUSE_MONTHS_CHANGED: "pause_months_changed",

  // Cancel plans dialog actions
  CANCEL_MODAL_VIEWED: "cancel_modal_viewed",
  CANCEL_PLAN_TOGGLED: "cancel_plan_toggled",
  CANCEL_FEATURES_VIEWED: "cancel_features_viewed",

  CANCEL_PLANS_CONFIRMED: "cancel_confirmed",
  CANCEL_MODAL_DISMISSED: "cancel_modal_dismissed",

  // Add_on manager dialog actions
  ADDON_BUNDLE_QUANTITY_CHANGED: "addon_quantity_changed",
  ADDON_PROFILE_TOGGLED: "addon_profile_toggled",
  ADDON_REMOVAL_INITIATED: "addon_removal_initiated",
  ADDON_PROFILES_DELETED: "addon_profiles_deleted",

  // Mutation results
  ADDON_REMOVE_SUCCESS: "addon_remove_success",
  ADDON_REMOVE_FAILED: "addon_remove_failed",
  REACTIVATION_FAILED: "reactivation_failed",
  RESUME_PLAN_SUCCESS: "resume_plan_success",
  RESUME_PLAN_FAILED: "resume_plan_failed",
  MISSING_FEATURE_LOADED: "missing_feature_loaded",
  MISSING_FEATURE_FAILED: "missing_feature_failed",

  // Navigation
  BACK_NAVIGATION: "back_clicked",
} as const;

export type TCheckoutEvent =
  (typeof CHECKOUT_EVENTS)[keyof typeof CHECKOUT_EVENTS];
